import { Loader2, Beaker } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { UploadZone } from "@/components/UploadZone";

// Image Panel (left column): upload zone or image preview + actions
export const ImagePanel = ({ imagePreview, isLoading, onImageSelect, onAnalyze, onReset }) => {
  const { t } = useLanguage();

  if (!imagePreview) {
    return <UploadZone onImageSelect={onImageSelect} isLoading={isLoading} />;
  }

  return (
    <div className="space-y-4 sticky top-6">
      <div className="image-preview" data-testid="image-preview">
        <img
          src={imagePreview}
          alt="Selected"
          className="w-full max-h-[400px] object-contain rounded-lg"
          style={{ backgroundColor: '#FFFFFF' }}
        />
      </div>

      <div className="flex gap-3">
        <button
          onClick={onAnalyze}
          disabled={isLoading}
          className="btn-primary flex-1 flex items-center justify-center gap-2"
          data-testid="analyze-button"
        >
          {isLoading ? (
            <>
              <Loader2 className="w-5 h-5 animate-spin" />
              {t.analyzing}
            </>
          ) : (
            <>
              <Beaker className="w-5 h-5" />
              {t.analyze}
            </>
          )}
        </button>

        <button
          onClick={onReset}
          disabled={isLoading}
          className="px-4 py-3 rounded-full border-2 font-body font-medium transition-all duration-300 hover:scale-105"
          style={{
            borderColor: '#DAD7CD',
            color: '#1A3C34',
            backgroundColor: 'transparent'
          }}
          data-testid="reset-button"
        >
          {t.newImage}
        </button>
      </div>
    </div>
  );
};
